<template>
  <table class="tile layout table-item-order boder-item">
    <tbody>
      <tr>
        <td style="width: 128px;">
          <div class="img-resize img-resize--small" style="margin-top: 16px">
            <!--eslint-disable-next-line--><!--prettier-ignore-->
            <img :src="item.product.image[0] || require('@/assets/images/goods_default.svg')"
              :alt="item.product.name"
              class="img-thumbnail"
            />
          </div>
        </td>
        <td>
          <div v-line-clamp="1" class="name_shop">{{ item.product.shopName }}</div>
          <div v-line-clamp="2" class="name_item">{{ productTitle }}</div>
          <div class="price_item">{{ formatPrice(item.product.price) }} {{ $t('common.ETH') }}</div>
          <div class="quantity_item">数量：{{ item.quantity }}</div>
          <div class="shipping_date">
            <span>{{ shippingDate(parseInt(item.product.detail.shipping_date)) }}</span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<style lang="scss" src="./item-order.scss" scoped>
</style>

<script>
import dataTransform from '@/utils/mixins/dataTransform';

export default {
  name: 'ItemOrder',
  components: {},
  mixins: [dataTransform],
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      radio: true,
      select: ''
    };
  },
  computed: {
    productTitle: function() {
      return this.item && this.item.product ? this.item.product.name : '';
    }
  },
  methods: {
    shippingDate(id) {
      const shippingDate = this.$t('shippingDate');
      return shippingDate && id > 0 ? `発送日の目安：入金後${shippingDate[id - 1].dates}` : '発送日の目安：';
    }
  }
};
</script>
